// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dnBU","fullView":"styles_fullView__pGOf_"};